////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.1                                                            //
//  Summary: Site footer — contact details, legal link, socials              //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////

import { Link } from 'react-router';

// Contact details verbatim from content/scrape/contact.md — do not diverge from the
// scraped source of truth without a corresponding content update.
export function Footer () {
  const year = new Date().getFullYear();

  // Solid paper — the one surface that sits at 100% opacity over the page
  // background (Mike, 12/08/2026): the footer reads as the page's "floor",
  // and muted text here is on solid paper, where it clears AA by definition
  // (see tokens.css), unlike over the 60% veil.
  return (
    <footer className="border-t border-line bg-paper">
      <div className="mx-auto max-w-6xl px-6 py-10 text-sm text-muted">
        <div className="flex flex-col gap-6 md:flex-row md:justify-between">
          <div>
            <p className="font-medium text-ink">IRONSIDE Construction Pty Ltd</p>
            <p>204 York Street, South Melbourne, Victoria 3205</p>
            <p>
              <a href="mailto:info@ironside.com.au" className="hover:text-ink">info@ironside.com.au</a>
              {' · '}
              <a href="tel:+61390683000" className="hover:text-ink">+61 3 9068 3000</a>
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <a
              href="https://www.instagram.com/ironside_construction/"
              target="_blank"
              rel="noreferrer"
              className="hover:text-ink"
            >
              Instagram
            </a>
            <Link to="/privacy-cookies-terms-conditions" className="hover:text-ink">
              Privacy, Cookies, Terms &amp; Conditions
            </Link>
          </div>
        </div>

        <p className="mt-8">&copy; {year} IRONSIDE Construction Pty Ltd. All rights reserved.</p>
      </div>
    </footer>
  );
}
